"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spinner = _interopRequireDefault(require("./spinner.svg"));
require("./styles.scss");
var _util = require("../../../util");
var BLOCK_CLASS = 'spinner';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Spinner = function Spinner(_ref) {
  var show = _ref.show;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.addClassNames)(BLOCK_CLASS, show ? "".concat(BLOCK_CLASS, "--shown") : "".concat(BLOCK_CLASS, "--hidden"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('mask')
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _spinner.default,
    alt: "a loading spinner",
    className: bem('logo')
  }));
};
Spinner.propTypes = {
  show: _propTypes.default.bool
};
Spinner.defaultProps = {
  show: false
};
var _default = Spinner;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');